import {
  IndividualStationFilterOption,
  OptionType,
} from '@app/components/stations/advanced-filter';
import { GipReportValues } from './types';

/**
 * Station ids from the advanced filter (individual stations) or the simple stations list.
 */
export function getGipStationIds(
  values: Pick<GipReportValues, 'stations' | 'stationsFilter'>,
): string[] {
  return (
    values.stationsFilter
      ?.filter((s): s is IndividualStationFilterOption => s.type === OptionType.IndividualStation)
      .map((s) => s.value.id) ??
    values.stations?.map((s) => s.id) ??
    []
  );
}
